// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import { ElevatorServiceMessage, ElevatorServiceMessageT } from './elevator-service-message';
import { EscalatorServiceMessage, EscalatorServiceMessageT } from './escalator-service-message';


export enum DeviceServiceContent {
  NONE = 0,
  ElevatorServiceMessage = 1,
  EscalatorServiceMessage = 2
}

export function unionToDeviceServiceContent(
  type: DeviceServiceContent,
  accessor: (obj:ElevatorServiceMessage|EscalatorServiceMessage) => ElevatorServiceMessage|EscalatorServiceMessage|null
): ElevatorServiceMessage|EscalatorServiceMessage|null {
  switch(DeviceServiceContent[type]) {
    case 'NONE': return null; 
    case 'ElevatorServiceMessage': return accessor(new ElevatorServiceMessage())! as ElevatorServiceMessage;
    case 'EscalatorServiceMessage': return accessor(new EscalatorServiceMessage())! as EscalatorServiceMessage;
    default: return null;
  }
}

export function unionListToDeviceServiceContent(
  type: DeviceServiceContent, 
  accessor: (index: number, obj:ElevatorServiceMessage|EscalatorServiceMessage) => ElevatorServiceMessage|EscalatorServiceMessage|null, 
  index: number
): ElevatorServiceMessage|EscalatorServiceMessage|null {
  switch(DeviceServiceContent[type]) {
    case 'NONE': return null; 
    case 'ElevatorServiceMessage': return accessor(index, new ElevatorServiceMessage())! as ElevatorServiceMessage;
    case 'EscalatorServiceMessage': return accessor(index, new EscalatorServiceMessage())! as EscalatorServiceMessage;
    default: return null;
  }
}
